/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { CreateTemplateInstanceSidebarContainer as CreateTemplateInstanceSideBar } from './CreateTemplateInstanceSidebar.container';
